import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AppConstants } from '../../../shared/constants/constants';
import { AuthService } from '../../../shared/services/auth.service';
import { environment } from '../../../../environments/environment';
import { BaseService } from '../../../shared/services/base.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { AppMessages } from '../../../shared/constants/messages';
import { AuthHelper } from '../../../common/auth.helper';
@Component({
  selector: 'callback-login',
  templateUrl: './callback-login.component.html'
})
export class CallbackLoginComponent implements OnInit {
  navigateUrl: string = '/select-centre';
  footer: string;
  // appConstants = AppConstants;
  constructor(private router: Router,
    private activeRouter: ActivatedRoute,
    private authService: AuthService,
    private baseService: BaseService,
    private dialogService: DialogService) {
  }
  ngOnInit() {
    this.baseService.getBuildVersion().subscribe(response => {
      if (response) {
        this.footer = response['_body'] || null;
      }
    });

    const lastAccessDate = new Date();
    localStorage.setItem(AppConstants.localStorage.lastAccessDate, lastAccessDate.toString());

    // /alert('lastAccessDate' + AppConstants.localStorage.lastAccessDate) ;

    // is autehnticated
    this.authService.getUser().then((user) => {
      if (user) {
        this.storeAuthorizeLocalStorage(user);
      } else {
          this.authService.signinRedirectCallback(environment.appUrl + this.router.url).then((user) => {
            this.storeAuthorizeLocalStorage(user);
          }).catch((error) => {
            console.log(error);
            AuthHelper.resetLocalStorage();
            window.location.href = '/landing';
          });
      }
    });

  }

  private storeAuthorizeLocalStorage(user: Oidc.User) {
    if (user != null) {
      // fix bug SD10001680-201 (account from MYTMB can not login to TMB)
      if (user.profile['role'].indexOf('Tmb') <= -1) {
        this.dialogService.openErrorDialog({ message: AppMessages.login.invalidPermission }).subscribe(
          (result) => {
            if (result) {
              this.baseService.logout();
            }
          });
      } else {
        // redirect to select-centre
        this.router.navigate([this.navigateUrl]);
      }
    }
  }
}


// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/auth/callback/callback-login.component.ts